// @ts-expect-error incompatibility with node16 resolution
import type {PortableTextBlock} from '@portabletext/types';
// @ts-expect-error incompatibility with node16 resolution
import {Transition} from '@headlessui/react';
import {SanityModuleVideo} from '../../../types';
import clsx from 'clsx';
import {useEffect, useState} from 'react';
import SanityImage from '../../media/SanityImage.client';
import sanityConfig from '../../../../sanity.config';

type Props = {
  node: PortableTextBlock & SanityModuleVideo;
};

export default function VideoBlock({node}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);

  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < 1024,
  );

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 1024);
    }

    if (typeof window !== 'undefined') handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  return (
    <section className={clsx('video-block', 'sm:px-12')}>
      <div className={clsx('container', 'my-10 md:my-20 md:w-full')}>
        <div>
          {node?.title && (
            <div className={'my-10 px-4 md:my-20 md:px-0'}>
              <h2 className="h1 font-bold text-blue">{node.title}</h2>
              {(node.subtitle || node.text) && (
                <div className="mt-4 max-w-[40rem] space-y-3">
                  {node.subtitle && <div className={'p'}>{node.subtitle}</div>}
                  {node.text && (
                    <div className="my-3 text-gray">{node.text}</div>
                  )}
                </div>
              )}
            </div>
          )}
          <div className={'relative'}>
            {(node?.desktop || node?.mobile) && (
              <div className={clsx('overflow-hidden md:rounded-lg')}>
                <Transition show={isOpen}>
                  <video
                    key={node._key}
                    autoPlay
                    controls
                    playsInline
                    className={clsx(
                      'relative aspect-video w-full', //
                    )}
                  >
                    {node.desktop && !isMobile && (
                      <source src={node.desktop} type="video/mp4" />
                    )}
                    {node.mobile && isMobile && (
                      <source src={node.mobile} type="video/mp4" />
                    )}
                  </video>
                </Transition>
                <Transition show={!isOpen}>
                  <button
                    className={clsx(
                      'absolute inset-0 z-10 grid aspect-video cursor-default place-content-center rounded-full',
                    )}
                  >
                    <svg
                      onClick={handleOpen}
                      className={clsx(
                        'h-[50px] w-[50px] cursor-pointer', //
                        'md:h-[80px] md:w-[80px]',
                        '2xl:h-[95px] 2xl:w-[95px]',
                      )}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 74 74"
                    >
                      <g
                        id="Group_652"
                        data-name="Group 652"
                        transform="translate(-873 -433)"
                      >
                        <circle
                          id="Ellipse_32"
                          data-name="Ellipse 32"
                          cx="37"
                          cy="37"
                          r="37"
                          transform="translate(873 433)"
                          fill="#E17836"
                        />
                        <path
                          id="Play_Icon"
                          data-name="Play Icon"
                          d="M18.693,7.3a5,5,0,0,1,8.614,0L41.553,31.46A5,5,0,0,1,37.247,39H8.753a5,5,0,0,1-4.307-7.54Z"
                          transform="translate(935 447) rotate(90)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </button>
                  {node.poster && (
                    <SanityImage
                      className={clsx(
                        'relative aspect-video w-full', //
                      )}
                      crop={node.poster.crop}
                      alt={node.poster?.altText}
                      dataset={sanityConfig.dataset}
                      hotspot={node.poster?.hotspot}
                      projectId={sanityConfig.projectId}
                      src={node.poster?.asset._ref}
                      layout="responsive"
                      sizes="100vw"
                    />
                  )}
                </Transition>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
